export default __webpack_public_path__ + "static/media/Asset 15.789abb29.png";